import React from 'react';
import {
  Flex,
  Box,
  Table,
  Tbody,
  Text,
  Thead,
  Tr,
  useColorModeValue,
  IconButton,
} from '@chakra-ui/react';
import {
  createColumnHelper,
} from '@tanstack/react-table';
import PageTable from 'components/layout/PageTable';
import AdminTableCell from 'components/layout/AdminTableCell';
import SortableTableHeader from 'components/layout/SortableTableHeader';
import { useSortableAdminTable } from 'hooks/useSortableAdminTable';
import { getSortableColumnOptions } from 'utils/tableColumnOptions';
import TablePagination from 'components/layout/TablePagination';
import CustomModal from './CustomModal';

const columnHelper = createColumnHelper();

export default function VehiclesTable({
  columnsData,
  data,
  page,
  setPage,
  totalPages,
  pageSize,
  setPageSize,
  handleUpdateVehicle,
  onEditVehicle,
  sorting,
  onSortingChange,
}) {
  const [modalState, setModalState] = React.useState({
    isOpen: false,
    data: null,
  });

  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const columns = React.useMemo(
    () => createColumns(columnsData),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [columnsData],
  );

  const table = useSortableAdminTable({
    data,
    columns,
    sorting,
    onSortingChange,
  });

  const openModal = (actionType, rowData) => {
    setModalState({ isOpen: true, data: { actionType, rowData } });
  };

  const closeModal = () => {
    setModalState({ isOpen: false, data: null });
  };

  function createColumns(columnsData) {
    return columnsData.map((col) =>
      columnHelper.accessor(col.accessor, {
        ...getSortableColumnOptions(col),
        header: () => <Text fontSize={{ sm: '10px', lg: '12px' }}>{col.Header}</Text>,
        cell: (info) => {
          const value = info.getValue();
          
          const displayValue = ['plate', 'chassisNumber', 'engineNumber'].includes(col.accessor) && typeof value === 'string'
            ? value.toUpperCase()
            : value;
  
          return (
            <Flex align="center">
              <Text fontSize="sm" fontWeight="normal">{displayValue}</Text>
              {col.actions && col.actions.map((action, index) => (
                <IconButton
                  key={index}
                  aria-label={action.label}
                  icon={action.icon}
                  size="sm"
                  variant="ghost"
                  colorScheme={action.colorScheme}
                  ml={2}
                  onClick={() => {
                    if (action.type === 'edit') onEditVehicle?.(info.row.original);
                    else if (action.type === 'view') openModal(action.type, info.row.original);
                  }}
                />
              ))}
            </Flex>
          );
        },
      }),
    );
  }
  

  return (
    <>
      <PageTable
        flexDirection="column"
        w="100%"
        px="0px"
       >
        <Box>
          <PageTable.Scroll>
            <Table variant="simple" color="gray.700" mb="24px" mt="12px">
                        <Thead>
                          {table.getHeaderGroups().map((headerGroup) => (
                            <Tr key={headerGroup.id}>
                              {headerGroup.headers.map((header) => (
                                <SortableTableHeader
                                  key={header.id}
                                  header={header}
                                  borderColor={borderColor}
                                />
                              ))}
                            </Tr>
                          ))}
                        </Thead>
                        <Tbody>
                          {table.getRowModel().rows.map((row) => (
                            <Tr key={row.id}>
                              {row.getVisibleCells().map((cell) => (
                                <AdminTableCell key={cell.id} cell={cell} />
                              ))}
                            </Tr>
                          ))}
                        </Tbody>
                      </Table>
          </PageTable.Scroll>

          <TablePagination
            page={page}
            setPage={setPage}
            totalPages={totalPages}
            pageSize={pageSize}
            setPageSize={setPageSize}
          />
        </Box>

        <CustomModal modalState={modalState} closeModal={closeModal} />
      </PageTable>
    </>
  );
}
